import React, { useEffect, useState, useRef, useCallback } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import { CanvasProps, IPorps } from './type';
// @ts-ignore
import pdfWorker from 'pdfjs-dist/webpack';
import tapIcon from 'assets/images/tap_100.png';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

// PDF 每頁的畫布
const Canvas:React.FC<CanvasProps> = ({ pageNum, pdf, show, scale }) => {
  // 是否渲染
  const [render, setRender] = useState(false);
  const canvasRef:any = useRef();

  // 渲染頁面
  const renderPage = useCallback((pdf) => {
    pdf.getPage(pageNum).then(function (page:any) {
      // 設定畫布尺寸
      const viewport = page.getViewport({ scale: scale });
      const canvas:any = canvasRef.current;
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      if (render) {
        // 渲染 PDF 畫面
        const renderContext = {
          canvasContext: canvas.getContext('2d'),
          viewport: viewport
        };
        page.render(renderContext);
      }
    });
  }, [pageNum, render, scale]);

  useEffect(() => {
    renderPage(pdf);
  }, [pdf, renderPage]);

  useEffect(() => {
    setRender(show);
  }, [show]);

  return <canvas ref={canvasRef} />;
};

// PDF 所有頁面檢視器
const PDFAllPageViewer:React.FC<IPorps> = ({ url, show, updateStatus, checkContracts }) => {
  const [pdfRef, setPdfRef] = useState<any>();
  // 頁面渲染狀態
  const [pageState, setPageState] = useState<any>();
  // 頁面尺寸縮放
  const [scale, setScale] = useState(1);
  // 頁面最初尺寸
  const [initScale, setInitScale] = useState(1);
  const pdfViewerContainerRef = useRef<any>(null);
  // 縮放級距
  const scaleVal = 0.1;
  let scrolling:any = null;

  // 渲染所有頁面
  const renderAllPages = (pdf:any = pdfRef) => {
    if (!pdf || !pageState) return;

    const pages = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      pages.push(<Canvas pageNum={i} pdf={pdf} show={pageState[`page${i}`]} key={`page${i}`} scale={scale} />);
    }

    return pages;
  };

  // 滾動事件
  const handleOnScroll = (e:any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 2;
    const pageHeight = e.target.scrollHeight / pdfRef.numPages;
    const currentPage = Math.floor(e.target.scrollTop / pageHeight) + 1;
    const nextPage = Math.floor(e.target.scrollTop / pageHeight) + 2;

    // 滾動至該頁面設定渲染該頁
    const handlePageRender = () => {
      if (nextPage <= pdfRef.numPages && pageState[`page${nextPage}`] === false) setPageState((prev:any) => ({ ...prev, [`page${nextPage}`]: true }));
      if (currentPage <= pdfRef.numPages && pageState[`page${currentPage}`] === false) setPageState((prev:any) => ({ ...prev, [`page${currentPage}`]: true }));
      if (bottom) {
        updateStatus(true);
        checkContracts();
      }
    };

    // 使用者滾動停留才進行渲染
    if (scrolling !== null) {
      clearTimeout(scrolling);
    }
    scrolling = (setTimeout(() => {
      handlePageRender();
    }, 100));
  };

  // 自動滾至底部
  const handleScrollToBottom = () => {
    pdfViewerContainerRef.current.scroll({ top: pdfViewerContainerRef.current.scrollHeight - pdfViewerContainerRef.current.clientHeight, behavior: 'smooth' });
  };

  // 調整尺寸
  const handleSetScale = (scaleVal:number) => {
    let newScale = scale;
    newScale += scaleVal;
    if (newScale < 0.5 || newScale >= 3) return;
    setScale(newScale);
  };

  useEffect(() => {
    // 取得 PDF
    const loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then((loadedPdf:any) => {
      setPdfRef(loadedPdf);
      const tempPageState:any = {};

      // 設定頁面狀態
      for (let i = 1; i <= loadedPdf.numPages; i++) {
        tempPageState[`page${i}`] = false;
      }
      setPageState(tempPageState);

      // 設定尺寸
      loadedPdf.getPage(1).then((page:any) => {
        if (pdfViewerContainerRef.current.clientWidth && page.getViewport({ scale: 1 }).width) {
          let scaleValue = Math.floor(((pdfViewerContainerRef.current.parentElement?.clientWidth - 20) / page.getViewport({ scale: 1 }).width) * 10) / 10;
          scaleValue = scaleValue < 0.5 ? 0.5 : scaleValue;
          setInitScale(scaleValue);
          setScale(scaleValue);
        }
      });
    }
    // , function (reason:any) {
    //   console.error(reason);
    // }
    );
  }, [url]);

  useEffect(() => {
    // 條款展開選染第一頁
    if (show && pageState && pageState.page1 === false) {
      setPageState((prev:any) => ({ ...prev, page1: true }));
    }
  }, [show, pageState]);

  return (
    <div className="pdf-all-page-viewer">
      <div className="pdf-all-page-viewer__container" onScroll={handleOnScroll} ref={pdfViewerContainerRef}>
        <div className="pdf-all-page-viewer__header">
          <p className="pdf-all-page-viewer__header-info">※捲動至最下方/閱讀完畢後將自動勾選。若無法勾選，請清除瀏覽器cookie後再重試</p>
          <div className="pdf-all-page-viewer__header-scale-ctrl">
            <button type="button" onClick={() => handleSetScale(scaleVal)}>放大</button>
            <button type="button" onClick={() => setScale(initScale)}>復原</button>
            <button type="button" onClick={() => handleSetScale(-scaleVal)}>縮小</button>
          </div>
        </div>
        <div className="pdf-all-page-viewer__content">
          {renderAllPages(pdfRef)}
        </div>
      </div>
      <button type="button" className="pdf-all-page-viewer__control" onClick={handleScrollToBottom}>
        <img src={tapIcon} alt="scroll to bottom" />
      </button>
    </div>
  );
};

export default PDFAllPageViewer;
